module.exports = __webpack_public_path__ + "media/images/icons/union-0d8b3666ce702a514b01ad0feadc0758.svg";